/* import __COLOCATED_TEMPLATE__ from './conversation-sla-target-missed.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import {
  truncateEventText,
  isEventTextTruncated,
  FEATURE_FLAG_NAME,
} from 'embercom/lib/inbox2/event-text-truncation';

interface Signature {
  Args: any;
}

export default class ConversationSlaTargetMissedComponent extends Component<Signature> {
  @service declare session: Session;

  get isConversationEventsUiImprovementsEnabled(): boolean {
    return this.session.workspace?.isFeatureEnabled(FEATURE_FLAG_NAME) ?? false;
  }

  get translationKey(): string {
    let prefix = this.isConversationEventsUiImprovementsEnabled
      ? 'target-missed-v2'
      : 'target-missed';
    let suffix = this.args.part.renderableData.slaTargetType || 'default';
    return `inbox.conversation-sla-target-missed.${prefix}.${suffix}`;
  }

  get truncatedSlaLabel(): string {
    return truncateEventText(this.args.part.renderableData.conversationSla.label);
  }

  get slaLabel(): string {
    return this.args.part.renderableData.conversationSla.label;
  }

  truncateTitle(title: string | undefined): string {
    return truncateEventText(title);
  }

  isTitleTruncated(title: string | undefined): boolean {
    return isEventTextTruncated(title);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ConversationSlaTargetMissed': typeof ConversationSlaTargetMissedComponent;
    'inbox2/conversation-stream/event-parts/conversation-sla-target-missed': typeof ConversationSlaTargetMissedComponent;
  }
}
